enum StatusEnum {
  OPEN = 'open',
  CLOSED = 'closed',
  REJECTED = 'rejected',
  WORKING = 'work',
}

interface Request {
  status: string;
  title: string;
  description: string;
  createDate: string;
  startDate: string;
  endDate: string;
}

type FindItem = { id: number };

interface IMentoringRequestCard extends Request {
  index: number;
  isOpenDescription: boolean;
  btnText: string;
  statusDictionary: () => [];
  thisStatus: string;
  statusText: string;
  statuses: string;
  startText: string;
  classColor: string;
  toggleDescription: () => void;
}

export { IMentoringRequestCard, StatusEnum, Request, FindItem };



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/requestcard/types.ts